import Navbar from "./components/Navbar";

function App() {
  return (
    <>
      <Navbar title="Unika InfoTech"/>
    </>
  );
}

export default App;